<template>
  <div>
    <d-modal v-if="artistModalVisible" @close="artistModalVisible = false">
      <d-modal-header>
        <d-input v-model="searchArtist" />
      </d-modal-header>
      <d-modal-body>
        <div
          v-for="(a, i) in filteredArtists"
          :key="i"
          @click="addArtistToEvent(a)"
          class="artist"
        >{{a.name}}</div>
      </d-modal-body>
    </d-modal>

    <b-row>
      <b-col cols="12" class="pl-0">
        <table v-if="events.length > 0" class="myTable">
          <thead>
            <tr>
              <th rowspan='2'>Artysta</th>
              <th v-if="categories && categories.length > 0" rowspan='2'>Kategoria</th>
              <th rowspan='2'>Nazwa wyświetlana</th>
              <th rowspan='2'>Data od</th>
              <th rowspan='2'>Data do</th>
              <th colspan='2' class="text-center">Ukryj w</th>
              <th rowspan='2' width="60"></th>
            </tr>
            <tr>
              <th class="text-center" width="80">Artyści</th>
              <th class="text-center" width="80">Program</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(event, idx) in events" :key="idx">
              <td>
                #{{ event.id }} 
                <d-btn
                  theme="light"
                  size="sm"
                  @click.prevent.stop="openArtistModal(event)"
                >{{ event.artistId == null ? 'Wybierz' : artist(event.artistId) }}</d-btn>
              </td>
              <td  v-if="categories && categories.length > 0">
                <b-form-select
                  class="form-control form-control-sm"
                  :options="[
                    { value: null, text: 'Wybierz kategorię' },
                    ...categories.map((c) => ({value: c.id, text: c.name.pl}))
                  ]"
                  v-model="event.categoryId"
                />
              </td>
              <td>
                <d-input
                  class="form-control form-control-sm"
                  v-model="event.name.pl"
                />
              </td>
              <td>
                <datetime
                  type="datetime"
                  input-class="form-control form-control-sm"
                  :value="event.dateFrom"
                   @input='(ev) => actions.handleEventPropChanged(event, "dateFrom", ev)'
                  :minute-step="5"
                  value-zone="local"
                  format="HH:mm"
                />
              </td>
              <td>
                <datetime
                  type="datetime"
                  input-class="form-control form-control-sm"
                  :value="event.dateTo"
                   @input='(ev) => actions.handleEventPropChanged(event, "dateTo", ev)'
                  :minute-step="5"
                  value-zone="local"
                  format="HH:mm"
                />
              </td>
              <td style="justify-items: center;">
                <b-form-checkbox
                  class="ml-2 mr-sm-2 mb-sm-0"
                  v-model='event.hideInArtists'
                />
              </td>
              <td style="justify-items: center;">
                <b-form-checkbox
                  class="ml-2 mr-sm-2 mb-sm-0"
                  v-model='event.hideInProgram'
                />
              </td>
              <td>
                <b-button
                  size="sm"
                  @click.prevent='(ev) => handleClickRemoveEvent(event)'
                  variant="danger"
                ><b-icon-trash /></b-button>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>
  </div>
</template>

<script>

  import {
    BIconTrash,
    BIconPencil,
    BIconCalendar,
    BIconPlus,
  } from 'bootstrap-vue'

  import {
    handleEventPropChanged,
    handleRemoveItemFromArray,
  } from '@/store/utils'

  export default {
    components: {
      BIconTrash,
    },
    props: ['day', 'scene'],
    data() {
      return {
        activeEvent: null,
        artistModalVisible: false,
        searchArtist: "",
        actions: {
          handleEventPropChanged,
          handleRemoveItemFromArray,
        }
      }
    },
    computed: {
      events() {
        if (this.scene.events && this.scene.events.length > 0) return this.scene.events.filter((it) => it.dayId === this.day.id);
        return [];
      },
      filteredArtists() {
        return this.searchArtist == ""
          ? []
          : this.$store.state.artists.all.filter(
              a =>
                a.name.toLowerCase().indexOf(this.searchArtist.toLowerCase()) > -1 &&
                a.fanzine_id === this.$store.state.fanzones.form.id
            );
      },
      categories() {
        return this.$store.state.fanzones.form.doc.scenesData.artistsCategories
      },
    },
    methods: {
      handleClickRemoveEvent(event) {
        if (confirm(`Usunąć wydarzenie [${event.name.pl}]?`) === true) {
          this.actions.handleRemoveItemFromArray(this.scene, "events", event)
        }
      },
      artist(id) {
        const a = this.$store.state.artists.all.filter((it) => it.id === id && it.fanzine_id === this.$store.state.fanzones.form.id);
        return a && a.length > 0 ? a[0].name : 'Zenek'
      },
      addArtistToEvent(artist) {
        this.actions.handleEventPropChanged(this.activeEvent, "artistId", artist.id)
        console.log("addArtistToEvent", JSON.stringify(artist))
      },
      openArtistModal(event) {
        this.activeEvent = event;
        this.artistModalVisible = true;
      },
    },
  }
</script>

<style lang="scss" scoped>
  .myTable {
    border: 1px solid #dcdcdc;
    border-collapse: collapse;
    width: 100%;
  }

  .myTable td, th {
    border: 1px solid #dcdcdc;
    padding: 5px;
  }
</style>